import { render, staticRenderFns } from "./WelcomPage.vue?vue&type=template&id=ee800d56&scoped=true&"
import script from "./WelcomPage.vue?vue&type=script&lang=js&"
export * from "./WelcomPage.vue?vue&type=script&lang=js&"
import style0 from "./WelcomPage.vue?vue&type=style&index=0&id=ee800d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee800d56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
